import React from 'react';
import { Trans } from 'react-i18next';

import useClassy from '@core/hooks/useClassy';

import Flex from '@ui/Flex';
import Icon from '@ui/Icon';

import classes from './style.module.scss';

function EmptyStatePrompt() {
  const bem = useClassy(classes, 'EmptyStatePrompt');
  return (
    <Flex align="center" className={bem('&')} gap="xs" justify="start">
      <Icon aria-hidden="true" className={bem('-icon')} isFont name="icon-help-circle" />
      <span className={bem('-label')}>
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <Trans components={{ a: <a href="#try-it" /> }} i18nKey="apiConfig.emptyStatePrompt" />
      </span>
    </Flex>
  );
}

export default EmptyStatePrompt;
